export const createBlobEventFactory = (nativeBlobEventConstructor) => {
    return (type, blobEventInit) => {
        // Bug #14: Safari does not yet support the BlobEvent.
        if (nativeBlobEventConstructor === null) {
            const { data, ...eventInit } = blobEventInit;
            const fakeBlobEvent = new Event(type, eventInit);
            fakeBlobEvent.data = data;
            return fakeBlobEvent;
        }
        return new nativeBlobEventConstructor(type, blobEventInit);
    };
};
//# sourceMappingURL=blob-event-factory.js.map